import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  banks: [],
  selectedBanks: [],
  addModal: false,
  isEdit: false,
  activeBank: null,
  searchQuery: {
    search: "",
    orderBy: "id",
    order: "asc",
  },
  page: 1,
  itemsPerPage: 10,
  totalItems: 0,
  isLoading: false,
};

const useProcessorStore = create(
  devtools((set) => ({
    ...initialState,
    setBanks: (t) => set({ banks: t }),
    setSelectedBanks: (t) => set({ selectedBanks: t }),
    setAddModal: (t) => set({ addModal: t }),
    setIsEdit: (t) => set({ isEdit: t }),
    setActiveBank: (t) => set({ activeBank: t }),
    setSearchQuery: (t) => set({ searchQuery: t }),
    setPage: (t) => set({ page: t }),
    setItemsPerPage: (t) => set({ itemsPerPage: t }),
    setTotalItems: (t) => set({ totalItems: t }),
    setIsLoading: (t) => set({ isLoading: t }),
    reset: () => set(initialState),
  })),
);

export default useProcessorStore;
